const CalendarRightArrowIcon = () => {
  return <svg stroke='currentColor' fill='currentColor' strokeWidth='0' viewBox='0 0 24 24' height='36' width='36' xmlns='http://www.w3.org/2000/svg' data-sentry-element="svg" data-sentry-component="CalendarRightArrowIcon" data-sentry-source-file="CalendarRightArrow.tsx">
      <path d='M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z' data-sentry-element="path" data-sentry-source-file="CalendarRightArrow.tsx"></path>
    </svg>;
};
export default CalendarRightArrowIcon;